// extracted by mini-css-extract-plugin
export var closeButton = "_ic-2";
export var closeButtonIcon = "_ic-3";
export var lightboxContent = "_ic-1";
export var lightboxOverlay = "_ic-0";